import {Routes} from '@angular/router';
import {multiUserGuard} from '@auth/guards';

export const reportsRoutes: Routes = [
  { path: 'reports', loadComponent: () => import('@reports/pages/home/home').then(m => m.Home), canActivate: [multiUserGuard]},
];
